export default `
    mutation(
        $input: AccountUploadInput
    ){
        accountUpload(
            input: $input
        ){
            url
        }
    }
`;